const getMarketFromQueryParam = (): undefined | string => {
  let marketFromQuery;
  if (typeof window !== 'undefined') {
    const { search } = window.location;
    marketFromQuery = new URLSearchParams(search).get('market')?.toLowerCase();
  }
  return marketFromQuery;
};

const getMarketFromPathname = (): undefined | string => {
  let marketFromPath;
  if (typeof window !== 'undefined') {
    marketFromPath = window.location.pathname
      ?.split('/')
      ?.filter?.((v) => !!v)?.[0]
      ?.toLowerCase?.();
  }
  return marketFromPath;
};

const getMarket = (): 'USA' | 'CAN' => {
  const value = getMarketFromQueryParam() ?? getMarketFromPathname();

  if (value?.startsWith('us')) return 'USA';

  return 'CAN';
};

export default getMarket;
